<template>
  <div class="pa-4">
    <v-card
      class="pa-6 mx-auto rounded-lg"
      elevation="0"
      max-width="1000"
      style="z-index: 100 !important"
    >
      <!-- Page 1: Cover -->
      <div id="page1">
        <div class="header">
          {{ $t('A instituição') }}
          <br />
          {{ institutionName }}
          <br />
          A/C: {{ toCareUser.name }}
        </div>

        <div class="pa-2">
          <br />
          <br />

          <p>
            {{ $t('ASSUNTO: Relatório de Desempenho') }}
          </p>

          <br />

          <p>
            {{
              $t(
                'Vimos por meio deste, formalizar a entrega do Relatório de Desempenho das atividades desempenhadas pelo setor durante o período na instituição'
              )
            }}
            {{ institutionName }}.
          </p>

          <br />

          <p>
            {{
              $t(
                'Para elaboração do mesmo, utilizamos os dados de apoio e indicadores gerados pelo software FixSystem - Software de gestão. Outros indicadores, listagens especificas ou maiores informações sobre o parque de equipamentos poderão ser solicitados pela administração se necessário.'
              )
            }}
          </p>

          <br />

          <p>
            {{
              $t(
                'A equipe permanece a inteira disposição e disponibiliza o contato dos responsáveis técnicos abaixo para o caso de qualquer dúvida'
              )
            }}:
          </p>

          <br />
          <br />

          <div class="d-flex justify-space-around">
            <div class="text-center">
              {{ executionUser.name }}
              <br />
              {{ offices[executionUser.userOffice] }}
              <br />
              {{ executionUser.cellPhoneNumber }}
            </div>

            <div class="text-center">
              {{ reviser.name }}
              <br />
              {{ reviser.userOffice }}
              <br />
              {{ reviser.cellPhoneNumber }}
            </div>
          </div>

          <br />
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <!-- Page 2: Objectives & Events -->
      <div id="page2">
        <div class="pa-2">
          <h2 class="primary--text my-4">{{ $t('Objetivos') }}:</h2>

          <p>
            {{
              'O presente relatório tem por objetivo apresentar os indicadores de desempenho, bem como as principais atividades realizadas pelo setor na instituição'
            }}
            {{ institutionName }}.
          </p>

          <br />

          <h2 class="primary--text my-4">
            {{ $t('Principais eventos do período') }}:
          </h2>

          <p class="text-start" style="white-space: pre-wrap">
            {{ lastEvents }}
          </p>

          <br />

          <h2 class="primary--text my-4">
            {{ $t('Eventos previstos para o próximo mês') }}:
          </h2>

          <p class="text-start" style="white-space: pre-wrap">
            {{ nextEvents }}
          </p>
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <!-- Page 3: Table of Contents -->
      <div class="page3">
        <div class="pa-2">
          <h2 class="primary--text">{{ $t('Indicadores de Desempenho') }}:</h2>
          <br />

          <p>
            {{
              $t(
                'O sistema de gestão da qualidade atualmente acompanha e supervisiona os seguintes indicadores de desempenho'
              )
            }}:
          </p>

          <br />

          <template v-for="cat in categoriesWithChartInfos">
            <div
              :key="cat.id + '-header'"
              class="d-flex align-center primary--text mt-4 mb-2"
            >
              <h2 class="mr-2">{{ cat.prefix }}.0</h2>
              <span style="font-size: 18px">
                {{ $t(cat.headerKey) }}
              </span>
            </div>

            <ul :key="cat.id + '-list'">
              <li
                v-for="ind in getChartInfoIndicators(cat.id)"
                :key="ind.id"
              >
                <div class="d-flex align-center">
                  <h3 class="mr-2">
                    {{ cat.prefix }}.{{ ind.displayNumber }}
                  </h3>
                  <span>{{ $t(ind.nameKey) }}</span>
                </div>
              </li>
            </ul>

            <br :key="cat.id + '-br'" />
          </template>
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <!-- Page 4+: Indicator Details -->
      <template v-for="cat in categoriesWithChartInfos">
        <div :key="cat.id + '-detail'" class="my-4">
          <div class="header">
            <div class="d-flex align-center ml-2" style="font-size: 16px">
              <h3 class="mr-2">{{ cat.prefix }}.0</h3>
              {{ $t(cat.headerKey) }}
            </div>
          </div>

          <IndicatorResultPanel
            v-for="ind in getChartInfoIndicators(cat.id)"
            :key="ind.id"
            :indicator="ind"
            :chartInfos="chartInfos"
            :institution="institution"
            :standardEquipments="standardEquipments"
            :useChartInfoUnidades="true"
          />
        </div>

        <v-divider :key="cat.id + '-divider'" class="ma-4"></v-divider>
      </template>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import GeneralService from '../../../services/GeneralService'
import IndicatorResultPanel from '../Reports/components/GenerateReport/components/IndicatorResultPanel.vue'
import {
  getCategoriesWithChartInfos,
  getChartInfoIndicatorsForCategory,
} from '../Reports/indicators/indicatorRegistry'

export default {
  name: 'GeneratedReportService',

  components: {
    IndicatorResultPanel,
  },

  data() {
    return {
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
        'Master',
      ],
      apiService: new ApiService(),
      generalService: new GeneralService(),
      loading: false,
      institution: {},
      report: {},
      chartInfos: [],
      standardEquipments: [],
      lastEvents: [],
      nextEvents: [],
      toCareUser: '',
      reviser: '',
      executionUser: '',
      institutionName: '',
    }
  },

  computed: {
    categoriesWithChartInfos() {
      return getCategoriesWithChartInfos(this.chartInfos, this.institution)
    },
  },

  async created() {
    await this.getReport()
  },

  methods: {
    getChartInfoIndicators(categoryId) {
      return getChartInfoIndicatorsForCategory(
        categoryId,
        this.chartInfos,
        this.institution
      )
    },

    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },

    async getReport() {
      this.loading = true
      await this.apiService
        .get(`generatedReport/link/${this.$route.params.link}`)
        .then(async (response) => {
          this.report = response.content
          const json = JSON.parse(this.report.content)

          this.institution = this.report.institution
          this.chartInfos = json.chartInfos
          this.lastEvents = json.lastEvents
          this.nextEvents = json.nextEvents
          this.toCareUser = json.toCareUser
          this.institutionName = json.institutionName
          this.reviser = json.reviser
          this.executionUser = json.executionUser

          await this.getStandardEquipments()

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.header {
  padding: 10px;
  background: #0f3565;
  color: white;
  border-radius: 6px;
  border-top-right-radius: 37px;
}
</style>
